import { IS_RN_WEBVIEW, SUPPORT_TICKET_URL } from 'constants/constants';
import i18n from 'i18n/config';
import { Alert } from 'styles/assets/icons';
import Box from 'UIKit/Box';
import DeltaButton from 'UIKit/DeltaButton';

import { RaiseDisable2FATicketInfo } from '../RaiseDisable2FATicketInfo/RaiseDisable2FATicketInfo';
import styles from './selfieVerificationFailed.module.scss';

const textSelfieVerificationFailed = i18n.t(
  'auth:twoFaFaceAuth.selfieVerificationFailed'
);

const textRaiseSupportTicket = i18n.t('common:raiseSupportTicket');

const SelfieVerificationRejected = ({ className }: { className?: string }) => {
  return (
    <Box className={className}>
      <Box className={styles.selfieFailedMsgContainer}>
        <Alert height={80} width={80} color="var(--negative)" />
        <Box as="h2" className={styles.heading}>
          {textSelfieVerificationFailed}
        </Box>
      </Box>
      <RaiseDisable2FATicketInfo
        btnSection={
          <DeltaButton
            as="a"
            className={styles.linkBtn}
            text={textRaiseSupportTicket}
            data-testid="selfie-failed-delta-support-ticket"
            target={IS_RN_WEBVIEW ? '_self' : '_blank'}
            href={SUPPORT_TICKET_URL}
            rel="noreferrer"
            // variant="primary-t1"
            fullWidth
          />
        }
      />
    </Box>
  );
};

export { SelfieVerificationRejected };
